import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthService } from '../services/auth.service';

import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    ButtonModule
],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css'
})
export class HomeComponent implements OnInit, OnDestroy {
  userAuthenticatedSubscription: Subscription;
  userAuthenticated: boolean = false;

  constructor(private authService: AuthService) {

    this.userAuthenticatedSubscription = this.authService.loginChanged.subscribe(res => {
      if (res) {
        this.userAuthenticated = true;
      }
    });
  }

  ngOnInit(): void {
    this.userAuthenticated = this.authService.isAuthenticated();
  }

  ngOnDestroy() {
    if (this.userAuthenticatedSubscription) {
      this.userAuthenticatedSubscription.unsubscribe();
    }
  }

  login() {
    this.authService.login();
  }
}
